import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const FarbwechselPolygon = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  // falls kein Wert vorhanden, dann 0 setzen
  if (value.value === "") {
    value.value = "0";
  }

  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Farbe anzeigen
  let color = "transparent";

  try {
    color = props.element.colors[idx];
  } catch (error) {}

  //========================================================================
  // Skalierungsfaktor
  const scale = props.scaleFactor ?? 1;

  //========================================================================
  // Koordinaten für die Fläche einlesen (bis zu 5 Punkte)
  const points = [];

  try {
    props.element.points.forEach((pointObj) => {
      const key = Object.keys(pointObj)[0];
      const p = pointObj[key];

      if (p && p.x !== undefined && p.y !== undefined) {
        const x = parseFloat(String(p.x).replace("px", "")) * scale;
        const y = parseFloat(String(p.y).replace("px", "")) * scale;

        if (!isNaN(x) && !isNaN(y)) {
          points.push({ x, y });
        }
      }
    });
  } catch (error) {}

  const pointsString = points.map((p) => `${p.x},${p.y}`).join(" ");

  // Nur zeichnen, wenn mindestens 3 Punkte vorhanden sind (sonst gar nichts anzeigen)
  const hasValidPolygon = points.length >= 3;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        backgroundColor: "transparent",
        userSelect: "none",
        position: "relative",
        overflow: "visible",
      }}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(value.name) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Variable: " + props.props.variable)
              : "")
      }
    >
      {hasValidPolygon && (
        <svg
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "visible",
            pointerEvents: "none",
          }}
        >
          <polygon points={pointsString} fill={color} />
        </svg>
      )}
      {language.displayText(props.props.text)}
    </div>
  );
});

export default FarbwechselPolygon;
